import { FC, useEffect } from 'react';

import { useResponse } from 'contexts/response';

import Dialog, { useDialog } from './dialog';

const ErrorDialog: FC<{ title?: string }> = ({ title = 'Request Failed' }) => {
  const { closeDialog, openDialog, ref } = useDialog();
  const { error, clearError } = useResponse();

  useEffect(() => {
    if (!error && ref.current?.open) {
      closeDialog();
    } else if (error && !ref.current?.open) {
      openDialog();
    }
  }, [error, ref, closeDialog, openDialog]);

  return (
    <Dialog closeDialog={clearError} ref={ref} data-cy="error-dialog">
      <div className="d-flex flex-column g-3">
        <h3 className="text-info-dark font-weight-medium">{title}</h3>
        <p className="text-info-main">{error}</p>
        <div className="grid-3 mt-3">
          <button type="button" className="btn-outline col-start-3" onClick={clearError}>
            close
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ErrorDialog;
